module.exports = __webpack_public_path__ + "static/beholder-xanathar-ca4efa567871a788373db617c8f44517.webp";